// Семантические цвета мини-аппа.
//
// Telegram-тема (bg/text/hint) задаётся самим клиентом и может быть
// светлой или тёмной — на неё мы не влияем. Эти же цвета —
// доменные акценты и статусные тона — фиксированы и подобраны так,
// чтобы читаться на обоих фонах. Применяются через inline-style
// (Tailwind не генерирует классы из runtime-строк).

// Акцент каждого крупного раздела. Цвет помогает мгновенно понять,
// в каком разделе находишься (вкладка снизу подсвечивается им).
export const DOMAIN = {
  payments: "#2563eb", // синий
  fx: "#0d9488", // бирюзовый
  exchange: "#7c3aed", // фиолетовый
  tasks: "#d97706", // янтарный
  more: "#64748b", // нейтральный
} as const;

// Тон статусной «таблетки» (StatusPill).
export type Tone = "neutral" | "info" | "success" | "warning" | "danger";

export const TONE: Record<Tone, string> = {
  neutral: "#64748b",
  info: "#2563eb",
  success: "#16a34a",
  warning: "#d97706",
  danger: "#dc2626",
};

// Полупрозрачная заливка того же цвета (~13% непрозрачности) —
// мягкий фон таблетки, корректный и на светлой, и на тёмной теме.
export function tint(hex: string): string {
  return hex + "22";
}
